var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgServiceCardArrow = function SvgServiceCardArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M11.667 15.83h7.924"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.213 15.83v-1.997l1.188.999 1.19.998-1.19.999-1.188.998z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    stroke: "#fff",
    strokeWidth: 2
  })));
};
export default SvgServiceCardArrow;